/// <reference types="vite/client" />

interface AppConfig {
  api: {
    baseUrl: string;
  };
  cloudFunctions: {
    receiptUrl: string;
  };
  app: {
    name: string;
    description: string;
    version: string;
    environment: string;
  };
  sentry: {
    dsn: string;
    enabled: boolean;
    environment: string;
  };
}

export const config: AppConfig = {
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || "http://localhost:8000/api",
  },
  cloudFunctions: {
    receiptUrl:
      import.meta.env.VITE_RECEIPT_CLOUD_FUNCTION_URL ||
      "https://europe-west3-munchioy-backend.cloudfunctions.net/sendOrderingReceipt",
  },
  app: {
    name: "Munchi Customer Portal",
    description: "All-in-one customer portal for loyalty management",
    version: "0.1.3",
    environment: import.meta.env.VITE_APP_ENV || "development",
  },
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN || "",
    enabled:
      import.meta.env.VITE_SENTRY_ENABLED === "true" ||
      import.meta.env.VITE_APP_ENV === "production",
    environment: import.meta.env.VITE_APP_ENV || "development",
  },
};
